import React, { FormEvent } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';

export interface CreateBatchDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  batchName: string;
  setBatchName: (value: string) => void;
  batchDescription: string;
  setBatchDescription: (value: string) => void;
  saving: boolean;
  onSubmit: (e: FormEvent<HTMLFormElement>) => Promise<void>;
}

export function CreateBatchDialog({
  open,
  onOpenChange,
  batchName,
  setBatchName,
  batchDescription,
  setBatchDescription,
  saving,
  onSubmit,
}: CreateBatchDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Novo Lote</DialogTitle>
          <DialogDescription>
            Crie um novo lote para organizar seus contatos.
          </DialogDescription>
        </DialogHeader>
        <form className="space-y-4" onSubmit={onSubmit}>
          <div className="space-y-2">
            <Label htmlFor="batch-name">Nome do Lote</Label>
            <Input
              id="batch-name"
              value={batchName}
              onChange={(e) => setBatchName(e.target.value)}
              placeholder="Ex: Campanha Dezembro"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="batch-description">Descricao (opcional)</Label>
            <Textarea
              id="batch-description"
              value={batchDescription}
              onChange={(e) => setBatchDescription(e.target.value)}
              placeholder="Descricao do lote..."
              rows={3}
            />
          </div>
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              disabled={saving}
            >
              Cancelar
            </Button>
            <Button type="submit" disabled={saving}>
              {saving ? 'Criando...' : 'Criar Lote'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
